import { useEffect } from 'react';

type EventParams = {
  [key: string]: string | number | boolean | undefined;
};

export const trackEvent = (eventName: string, params?: EventParams) => {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag('event', eventName, params);
  }
};

export const usePhoneClickTracking = () => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a[href^="tel:"]') as HTMLAnchorElement | null;
      
      if (link) {
        const phoneNumber = link.getAttribute('href')?.replace('tel:', '') || '';
        trackEvent('click', {
          link_type: 'phone',
          link_url: phoneNumber,
          page_location: window.location.pathname
        });
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
};
